module.exports = __webpack_public_path__ + "static/media/1_02.55d40245.png";